export enum SessionStorageEnum {
  SEARCH = 'SEARCH',
  USERLOCATIONSTATE = 'USERLOCATIONSTATE',
  WIDGETDATA = 'WIDGETDATA',
  COOKIEBANNER = 'COOKIEBANNER',
  MAILCHIMPPOPUP = 'MAILCHIMPPOPUP',
  CLOSEABLEAD = 'CLOSEABLEAD',
  IEWARNING = 'IEWARNING',
  TOPALERT = 'TOPALERT',
  DOKTORSECHAT = 'DOKTORSECHAT',
  MOBILEPOPUPBANNER = 'MOBILEPOPUPBANNER',
  SESSION_ID = 'SESSIONID',
  AUTH_TOKEN = 'auth',
}
